import { createContext, useContext } from 'react'

/**
 * Cells need one thing only: the set of card ids matching the active filters, or null
 * when no filter is set. Keeping counts and facets out of this context means the value
 * stays referentially `null` while filtering is off, so editing a card cannot rerender
 * all 200 cells.
 */
export const MatchSetContext = createContext<ReadonlySet<string> | null>(null)

export function useMatchSet(): ReadonlySet<string> | null {
  return useContext(MatchSetContext)
}
